import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/lib/auth-context";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { WhatsAppIcon } from "@/components/WhatsAppButton";

export default function WhatsAppSettingsCard() {
  const { isSuperAdmin } = useAuth();
  const [form, setForm] = useState({ number: "", enabled: true });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/whatsapp").then(({ data }) => setForm(data)).catch((e) => toast.error(formatError(e)));
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/whatsapp", form);
      setForm(data);
      toast.success("WhatsApp settings saved");
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="w-card w-card-bordered p-6 space-y-4 mt-6" data-testid="whatsapp-settings-card">
      <div className="flex items-center gap-3">
        <div className="h-9 w-9 rounded-full grid place-items-center text-white" style={{ background: "#25D366" }}>
          <WhatsAppIcon className="h-5 w-5" />
        </div>
        <div>
          <h3 className="font-bold">Contact & WhatsApp</h3>
          <p className="text-xs" style={{ color: "var(--text-muted)" }}>
            Floating chat button on the landing page and customer portal.
            {!isSuperAdmin && " Only the super admin can change these settings."}
          </p>
        </div>
      </div>
      <div className="grid sm:grid-cols-[1fr_auto] gap-4 items-end">
        <div className="space-y-1.5">
          <Label>WhatsApp number (international format)</Label>
          <Input value={form.number} disabled={!isSuperAdmin} placeholder="+971527184369"
                 onChange={(e) => setForm((f) => ({ ...f, number: e.target.value }))}
                 data-testid="whatsapp-number-input" />
        </div>
        <div className="flex items-center gap-3 pb-2">
          <Switch checked={form.enabled} disabled={!isSuperAdmin}
                  onCheckedChange={(v) => setForm((f) => ({ ...f, enabled: v }))}
                  data-testid="whatsapp-enabled-switch" />
          <Label>Show button</Label>
        </div>
      </div>
      {isSuperAdmin && (
        <Button type="button" onClick={save} disabled={busy} className="rounded-xl bg-navy text-white"
                data-testid="whatsapp-save-btn">
          {busy ? "Saving…" : "Save WhatsApp settings"}
        </Button>
      )}
    </div>
  );
}
